import { openAtom } from "@mongez/react-atom";

export const cartDrawerAtom = openAtom("cartDrawerAtom");
